import React, { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { collection, getDoc, getDocs, doc } from "firebase/firestore";
import { db } from "../firebase";
import text from "../constants/text.json";
import { imageObject } from "../constants/image";
import color from "../constants/colors.json";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "../App.css";
import styles from "./WebsiteLayout.module.css";
import { fetchAdminContentDoc } from "../utils/adminContent";

const DOCUMENT_PATHS = ["/privacy-policy", "/eula", "/terms-and-conditions"];

export default function WebsiteLayout() {
  const isRtl = false;
  const [content, setContent] = useState({});
  const location = useLocation();

  useEffect(() => {
    async function getWebsiteContent() {
      try {
        const data = await fetchAdminContentDoc(db, {
          getDoc,
          getDocs,
          collection,
          doc,
        });
        if (data) setContent(data);
      } catch (e) {
        console.log("Error: ", e);
      }
    }
    getWebsiteContent();
  }, []);

  /** Order: Home → EULA → Privacy Policy → Terms & Conditions (LTR). */
  const navbarNavItems = useMemo(
    () => [
      { to: "/", end: true, label: text.EngHome },
      { to: "/eula", label: text.Eng14 },
      { to: "/privacy-policy", label: text.Eng11 },
      { to: "/terms-and-conditions", label: text.Eng15 },
    ],
    []
  );

  const outletContext = useMemo(
    () => ({
      content,
      isRtl,
      text,
      imageObject,
      color,
    }),
    [content, isRtl]
  );

  const footerProps = {
    about: text.Eng9,
    features: text.Eng10,
    policy: text.Eng11,
    contact: text.Eng4,
    reserved: text.Eng12,
    image: imageObject.image4,
  };

  const isDocumentView = DOCUMENT_PATHS.includes(location.pathname);

  return (
    <div className="App">
      <link rel="stylesheet" href="./css/bootstrap.css" />
      <link rel="stylesheet" href="./fonts/icon-font/css/style.css" />
      <link rel="stylesheet" href="./fonts/typography-font/typo.css" />
      <link rel="stylesheet" href="./fonts/fontawesome-5/css/all.css" />
      <link
        href="https://fonts.googleapis.com/css2?family=Karla:wght@300;400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap"
        rel="stylesheet"
      />

      <div className={styles.shell}>
        <Navbar
          color={color}
          imageObject={imageObject}
          navItems={navbarNavItems}
        />
        <div className={styles.main} dir={isRtl ? "rtl" : "ltr"}>
          <div
            className={`${styles.mainInner} ${
              isDocumentView ? styles.mainInnerDocument : ""
            }`}
          >
            <Outlet context={outletContext} />
          </div>
          <div className={styles.footerWrap}>
            <Footer {...footerProps} />
          </div>
        </div>
      </div>
    </div>
  );
}
